var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EE5F10",
    fillRule: "evenodd",
    d: "M8 10.667c-.368 0-.666-.299-.666-.667 0-.368.298-.667.666-.667.368 0 .667.299.667.667 0 .368-.299.667-.667.667M8 8c-1.102 0-2 .897-2 2s.898 2 2 2c1.103 0 2-.897 2-2s-.897-2-2-2m4 4.667c0 .368-.298.666-.666.666H4.667c-.368 0-.667-.298-.667-.666V7.333c0-.368.299-.666.667-.666h6.667c.368 0 .666.298.666.666v5.334zM6.667 4.074c0-.776.598-1.407 1.333-1.407.736 0 1.334.631 1.334 1.407v1.26H6.667v-1.26zm4.667 1.26h-.667v-1.26c0-1.51-1.196-2.74-2.667-2.74-1.47 0-2.666 1.23-2.666 2.74v1.26h-.667c-1.103 0-2 .897-2 2v5.333c0 1.102.897 2 2 2h6.667c1.102 0 2-.898 2-2V7.333c0-1.102-.898-2-2-2z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock.e6bffbd4.svg";
export { ForwardRef as ReactComponent };